import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {Siteinfo} from "../../bean/siteinfo";
import {Events} from "ionic-angular";

/*
  Generated class for the SiteinfoProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SiteinfoProvider {
    url = environment;
    info: Siteinfo;

    constructor(
        public http: HttpClient,
        public events: Events,
    ) {
        this.http.get(environment.config + '?type=site_info').subscribe(data => {
            if (data['err_code'] == '') {
                this.info = new Siteinfo(data['data']);
                this.events.publish('site:info', this.info);
            }
        });
    }

    getInfo() {
        return this.info;
    }


}



// WEBPACK FOOTER //
// ./src/providers/siteinfo/siteinfo.ts